import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import _ from "lodash";
import loanSeniorityTypes from "constants/loanSeniorityTypes";
import numeral from "numeral";

import { DateItem,
  TextItem,
  CurrencyItem,
  PercentItem,
  PercentNoDecimalItem,
  DscrItem,
  ItemLinks, NoItems, getMinValue, getExtensionTriggers, getListItemLink, makePercent, makeDSCR } from "../util";
import { ItemList } from "../styles";

const getPercentField = (selectedLoan, field) => {
  const value = _.get(selectedLoan, field);

  return value ? (value * 100) : "";
};
const mapLoansToLinkElements = (loans, selectedLoan, handleSelect, type) => loans.filter(x => x.loanSeniorityId === type)
  .map(loan => getListItemLink(loan, selectedLoan, handleSelect));
const seniorLoanLinks = (loans, selectedLoan, handleSelect) => mapLoansToLinkElements(loans, selectedLoan, handleSelect, loanSeniorityTypes.SENIOR);
const subordinateLoanLinks = (loans, selectedLoan, handleSelect) => mapLoansToLinkElements(loans, selectedLoan, handleSelect, loanSeniorityTypes.SUBORDINATE);

const supplementalLoanLinks = (loans, selectedLoan, handleSelect) => mapLoansToLinkElements(loans, selectedLoan, handleSelect, loanSeniorityTypes.SUPPLEMENTAL);

const nonspecifiedLoanLinks = (loans, selectedLoan, handleSelect) => {
  loans.filter(x => !x.loanSeniorityId)
    .map(loan => getListItemLink(loan, selectedLoan, handleSelect));
};

export const LeftSide = ({ selectedLoan }) => {
  const { closingDate, maturityDate, interestOnlyMonthsRemaining, currentPrincipalBalance, currentPayment } = selectedLoan;

  return (
    <Grid item md={6} sm={12} xs={12} id="closedLoansInfoLeft">

      <DateItem
        value={closingDate}
        label="Closing Date"
      />
      <DateItem
        value={maturityDate}
        label="Maturity"
      />
      <CurrencyItem
        value={currentPrincipalBalance}
        label="Current Balance"
      />
      <CurrencyItem
        value={currentPayment}
        label="Current Payment"
      />
      <TextItem
        value={_.get(selectedLoan, "rateTypeRef.name")}
        label="Rate Type"
      />
      <PercentItem
        value={getPercentField(selectedLoan, "allInRate") / 100}
        label="All-In Rate"
      />
      <TextItem
        value={_.get(selectedLoan, "index.name")}
        label="Index"
      />
      <PercentItem
        value={getPercentField(selectedLoan, "loanSpread")}
        label="Spread"
      />
      <PercentItem
        value={getPercentField(selectedLoan, "indexFloor")}
        label="Floor"
      />
      <TextItem
        value={interestOnlyMonthsRemaining}
        label="I/O Remaining"
      />
    </Grid>
  );
};

export const RightSide = ({ selectedLoan }) => {
  const extensionRemaining = _.get(selectedLoan, "extensionTerms.extensionRemaining");

  const ltvStabilized = _.get(selectedLoan, "extensionTerms.ltvReq");
  const dscrStabilized = _.get(selectedLoan, "covenants.dscrStabilized");
  const dscrReq = _.get(selectedLoan, "extensionTerms.dscrReq");
  const debtYieldStabilized = _.get(selectedLoan, "extensionTerms.debtYieldReq");
  const { prepaymentPenalty } = selectedLoan;

  return (
    <Grid item md={6} sm={12} xs={12} id="closedLoansInfoRight">

      {!selectedLoan.isLockout &&
        <CurrencyItem
          value={prepaymentPenalty}
          label="Prepayment Penalty"
        />}
      {selectedLoan.isLockout &&
        <TextItem
          value={"LOCKOUT"}
          label="Prepayment Penalty"
        />}
      <TextItem
        value={_.get(selectedLoan, "loanRecourse.recourseType.name")}
        label="Recourse"
      />
      <PercentItem
        value={getPercentField(selectedLoan, "covenants.ltvStabilized")}
        label="Maximum LTV"
      />
      <DscrItem
        value={dscrStabilized}
        label="Minimum DSCR"
      />
      <PercentItem
        value={getPercentField(selectedLoan, "covenants.debtYieldStabilized")}
        label="Minimum Debt Yield"
      />
      <CurrencyItem
        value={getMinValue(selectedLoan.guarantors, "netWorth")}
        label="Minimum Net Worth"
      />
      <CurrencyItem
        value={getMinValue(selectedLoan.guarantors, "liquidity")}
        label="Minimum Liquidity"
      />
      <CurrencyItem
        value={_.get(selectedLoan, "covenants.minCashDeposit")}
        label="Minimum Cash Deposits"
      />
      <TextItem
        value={extensionRemaining}
        label="Extension Remaining"
      />
      <TextItem
        value={getExtensionTriggers(makePercent(ltvStabilized), makeDSCR(dscrReq), makePercent(debtYieldStabilized))}
        label="Extension Triggers"
      />
    </Grid>
  );
};

export const ClosedLoanComponent = ({ loans, Link, fundId, dealId, handleSelect, selectedLoan }) => {
  if (!loans || loans.length === 0) {
    return <NoItems Message={"There are no closed loans for this deal."} />;
  }

  if (selectedLoan === null) {
    return null;
  }

  return (
    <>
      <Grid container spacing={8} alignItems="flex-start" justify="flex-start" direction="row">
        <Grid item lg={3} md={4} sm={4} xs={4}>
          <ItemList id="closedLoansList">
            {seniorLoanLinks(loans, selectedLoan, handleSelect)}
            {subordinateLoanLinks(loans, selectedLoan, handleSelect)}
            {supplementalLoanLinks(loans, selectedLoan, handleSelect)}
            {nonspecifiedLoanLinks(loans, selectedLoan, handleSelect)}
          </ItemList>
        </Grid>
        <Grid item lg={8} md={8} sm={8} xs={8}>
          <Grid container spacing={8} alignItems="flex-start" justify="flex-start" direction="row">
            <LeftSide selectedLoan={selectedLoan} />
            <RightSide selectedLoan={selectedLoan} />
          </Grid>
        </Grid>
      </Grid>

      <ItemLinks
        itemName={`Loan${selectedLoan.id}`}
        DetailsLink={`/portfolio/funds/${fundId}/deals/${dealId}/loans/${selectedLoan.id}/loanDetailsPage/0`}
        shouldShowCashflowsLink
        CashflowsLink={`/portfolio/funds/${fundId}/deals/${dealId}/cashflowsPage?showActiveLoans=true&loanId=${selectedLoan.id}`}
        Link={Link}
      />

    </>);
};
